import { useCurrentSofa } from '@/hooks/use-current-sofa'
import { useTranslate } from '@/hooks/use-translate'

// https://react.dev/reference/react-dom/components/title#use-variables-in-the-title

export function DocumentTitle() {
  const appName = useTranslatedAppName()
  return <title>{`${appName}`}</title>
}

export function DocumentTitleWithCurrentSofa() {
  const appName = useTranslatedAppName()
  const { productData } = useCurrentSofa()
  return <title>{`${appName} | ${productData.content.name}`}</title>
}

function useTranslatedAppName() {
  const { translateString } = useTranslate()
  // TODO: Specific app title?
  return translateString('startpage.intro.title')
}
